import { Container, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import MarketHeader from "./Component/MarketHeader";
import MarketTabs from "./Component/TableMarket/MarketTabs";
import TableMarket from "./Component/TableMarket";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import { getInvestmentMarketList } from "store/slices/market/marketSlice";
import { repeat } from "utils/helpers/interval";
import { search } from "utils/helpers/search";
import useDispatch from "hooks/useDispatch";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

let getMarketLoggedInListInterval = null;

export function Market() {
  const isUserBlocked = useIsUserBlocked();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const brokerId = searchParams.get("brokerId") || 0;
  const coinDestinationId = searchParams.get("coinDestinationId") || -1;
  const coinSourceId = searchParams.get("coinSourceId") || -1;

  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState();

  const marketList = useSelector(
    (state) => state.market.investmentMarketList?.data
  );

  const handleGetMarketLoggedInList = async ({ hasLoading }) => {
    if (hasLoading) {
      setLoading(true);
    }

    await dispatch(
      getInvestmentMarketList({
        brokerId,
        coinDestinationId,
        coinSourceId,
      })
    );

    setLoading(false);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchedMarketList = useMemo(() => {
    return search({
      list: marketList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [marketList, value]);

  useEffect(() => {
    handleGetMarketLoggedInList({ hasLoading: true });

    clearInterval(getMarketLoggedInListInterval);

    getMarketLoggedInListInterval = repeat({
      action: () =>
        handleGetMarketLoggedInList({
          hasLoading: false,
        }),
    });

    return () => {
      clearInterval(getMarketLoggedInListInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brokerId, coinDestinationId, coinSourceId]);

  return (
    <Container maxWidth="100%">
      {/* {isMobileView && (
        <Grid item xs={12} mt={3}>
          <TabsStyle value={location.pathname} onChange={handleChangeTabTop}>
            <Tab label="Exchange" value={"/market"} />
            <Tab label="P2P" value={"/p2p"} />
          </TabsStyle>
        </Grid>
      )} */}

      {!isUserBlocked && <MarketHeader value={value} onChange={handleSearch} />}

      <MarketTabs />

      {!loading ? (
        <TableMarket marketList={searchedMarketList} />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <TableSkeleton />
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

export default Market;
